<template>
  <div class="product">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="text">
          <h5>光伏/风电<br />快速频率响应控制装置</h5>
          <h6>KUAI SU PIN LV XIANG YING KONG ZHI ZHUANG ZHI</h6>
          <p>快速调频 安全可靠</p>
        </div>
        <figure class="img">
          <img
            src="../../assets/img/product/product3_banner.png"
            style="width: 400px"
            alt
          />
        </figure>
      </div>
    </div>

    <!-- 切换 -->
    <!-- <div class="platform-wrap">
        <a class="btn-gf btn-gotogf active" href="javascript:;" >
            <i class="icon-gf"></i>光伏
        </a> 
        <a class="btn-fd btn-gotofd" @click="toFD">
            <i class="icon-fd"></i>
            风电
        </a>
    </div> -->

    <!-- <div class="product-containedr"> -->
    <!-- <div class="gf-container"></div> -->
    <div style="margin-bottom:30px;"></div>
    <div class="productgf-img1 productgf-img">
      <div class="content">
        ● 行业成熟大型水电厂电调柜的核心技术<br />
        ● 多路电气硬件测频技术<br />
        ● 微电网及新能源能量管理系统的技术<br />
        ● 针对电科院新的研究成果提出的新能源的快速调频算法
      </div>
    </div>

    <div class="productgf-img-outwrap">
      <div class="container productgf-img2 productgf-img">
        <div class="content">
          ● 已有电站的AGC系统进行扩展硬件测频功能应用<br />
          ● 通过独立频率控制柜进行各逆变器的快速功率控制<br />
          ● 计算对应积分调节电量<br />
          ● 参与两个细则考核
        </div>
      </div>
    </div>

    <div class="container productgf-img3">
      <div class="title">
        按照国家能源局西北监管局《西北电网新能源场站快速频率响应功能推广应用工作方案》以及
        <br />DL/T 1870-2018 电力系统网源协调技术规范制定本方案。
      </div>
      <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">
            <i class="el-icon-sunny"></i>
            <span slot="title">光伏</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-wind-power"></i>
            <span slot="title">风电</span>
          </el-menu-item>
        </el-menu> -->
      <div style="margin-top: 30px">
        <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
          <el-tab-pane name="gf">
            <span slot="label"><i class="el-icon-sunny"></i>光伏</span>
            <img class="tabs-img" src="../../assets/img/product/news_1.jpg" />
            <div class="tabs-text">
              主要控制性能指标：<br />
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    ● 快速频率响应死区±0.06<br />
                    ● 系统调差率为3%<br />
                    ● 功率限幅为±10%PN<br />
                    ● thx 响应滞后时间小于2秒<br />
                    ● t0.9 响应时间小于5秒<br />
                    ● ts 调节时间小于15秒<br />
                    ● 频率控制偏差为额定出力±1%<br />
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    ● 测频精度指标：0.001Hz<br />
                    ● 频率采样周期：100mS<br />
                    ● 有功控制周期：小于1秒<br />
                    ● 能躲过单一短路故障带来的频率变化<br />
                    ● thx 响应滞后时间小于2秒<br />
                    ● t0.9 响应时间小于5秒<br />
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane name="fd">
            <span slot="label"><i class="el-icon-wind-power"></i>风电</span>
            <img class="tabs-img" src="../../assets/img/product/news_2.jpg" />
            <div class="tabs-text">
              主要控制性能指标：<br />
              <el-row>
                <el-col :span="12">
                  <div class="grid-content bg-purple">
                    ● 快速频率响应死区±0.1<br />
                    ● 系统调差率为2%<br />
                    ● 功率限幅为±10%PN<br />
                    ● thx 响应滞后时间小于2秒<br />
                    ● t0.9 响应时间小于12秒<br />
                    ● ts 调节时间小于15秒<br />
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple-light">
                    ● 频率控制偏差为额定出力±1%<br />
                    ● 测频精度指标：0.001Hz<br />
                    ● 频率采样周期：100mS<br />
                    ● 有功控制周期：小于1秒<br />
                    ● 能躲过单一短路故障带来的频率变化<br />
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "Product3",
  data() {
    return {
      activeIndex: "1",
      activeName: "gf",
    };
  },
  methods: {
    toFD() {
      this.$router.push("/product32");
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="scss">
.product {
  width: 100%;
  height: 100%;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

.container {
  width: 1200px;
  max-width: 1200px;
  padding: 0;
}

/* element-ui */
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

/* 
    banner
*/
.banner {
  width: 100%;
  height: 360px;
  background: #2f9eff;
}
.banner .container {
  position: relative;
  margin: 0 auto;
  height: 360px;
}
.banner .text {
  position: absolute;
  left: 150px;
  top: 50%;
  transform: translate(0, -50%);
  color: #fff;
}
.banner .text h5 {
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 2.5px;
}
.banner .text h6 {
  font-size: 12px;
  margin: 12px 0 20px;
  font-weight: bold;
  opacity: 0.5;
  letter-spacing: 1.5px;
}
.banner .text p {
  font-size: 16px;
  letter-spacing: 2px;
}
.banner .img {
  position: absolute;
  right: 150px;
  bottom: -30px;
}

// 切换
.platform-wrap {
  width: 100%;
  height: 61px;
  border-bottom: 1px solid #e5e5e5;
  text-align: center;
}

.platform-wrap > a:hover,
.platform-wrap > a.active {
  color: #fff;
  background: linear-gradient(to right, #2895f8, #30a9f9);
  background-color: #2895f8;
}

.platform-wrap > a {
  display: inline-block;
  margin: 12px 77px 0;
  width: 142px;
  height: 36px;
  line-height: 36px;
  border-radius: 18px;
  color: #000;
  font-size: 14px;
  text-decoration: none;
}

.platform-wrap > a:hover .icon-gf,
.platform-wrap > a.active .icon-gf {
  background: url(../../assets/img/product/icon_gf.png) center;
}

.platform-wrap > a:hover .icon-fd,
.platform-wrap > a.active .icon-fd {
  background: url(../../assets/img/product/icon_fd.png) center;
}

.platform-wrap > a .icon-gf {
  display: inline-block;
  width: 22px;
  height: 22px;
  position: relative;
  left: -10px;
  top: 6px;
  background: url(../../assets/img/product/icon_gf_blue.png) center;
}

.platform-wrap > a .icon-fd {
  display: inline-block;
  width: 24px;
  height: 24px;
  position: relative;
  left: -10px;
  top: 6px;
  background: url(../../assets/img/product/icon_fd_blue.jpg) center;
}

.gf-container {
  background: url(../../assets/img/product/product3_title.png) no-repeat center;
  width: 397px;
  height: 36px;
  text-align: center;
  margin: 0 auto;
  margin-top: 70px;
}

.productgf-img {
  position: relative;

  .content {
    position: absolute;
    text-align: left;
    color: #666;
    font-size: 14px;
    line-height: 25px;
    max-width: 512px;
    min-width: 512px;
    margin-bottom: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}

.productgf-img1 {
  width: 1200px;
  height: 599px;
  margin: 0 auto;
  background: url(../../assets/img/product/product3_1.png);

  .content {
    left: 85px;
    top: 250px;
  }
}

.product-img-outwrap,
.productgf-img-outwrap {
  width: 100%;
  background-color: #fcfcfc;
}

.productgf-img2 {
  width: 1200px;
  height: 599px;
  background: url(../../assets/img/product/product3_2.png);
  margin: 0 auto;

  .content {
    left: 840px;
    top: 240px;
  }
}

.productgf-img3 {
  width: 1200px;
  height: 900px;
  background: url(../../assets/img/product/product3_3.png) top center no-repeat;
  margin: 0 auto;
  overflow: hidden;

  .content {
    left: 840px;
    top: 240px;
  }

  .title {
    width: 850px;
    margin: auto;
    line-height: 22px;
    text-align: center;
    color: #808080;
    font-size: 15px;
    margin-top: 140px;
  }

  .el-menu {
    margin: 0 auto;
    padding-left: 450px;
  }
  .el-menu-item {
    width: 150px;
    text-align: center;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    font-weight: normal;
  }

  .el-tabs {
    width: 800px;
    margin: 0 auto;
  }
  .tabs-img {
    width: 100%;
  }
  .tabs-text {
    color: #666;
    font-size: 14px;
    line-height: 25px;
    max-width: 512px;
    min-width: 512px;
    margin-bottom: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}
</style>